import Vue from "vue";
import App from "./App.vue";
import scroll from 'vue-seamless-scroll'
import pdf from 'vue-pdf'
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import ECharts from "vue-echarts/components/ECharts";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import BaiduMap from "vue-baidu-map";
import "./assets/css/index.css";
import "./assets/css/responsive.css";
import "./assets/css/visual.css";
import "@/permission"; // permission control

Vue.component("v-chart", ECharts);
Vue.use(ElementUI);
Vue.use(VueAxios, axios);
Vue.use(BaiduMap, {
  ak: "2WGE2ADrI9wvPb0yFxXzrGAD0groO5WO"
});
Vue.use(scroll);
Vue.use(pdf);
Vue.config.productionTip = false;
// 导航守卫，保证每次切换路由滚动条滚动到顶部
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
